import beforeLoginAxios from "../../../Util/API Calls/beforeLogin";

export const doctorSendOTP = async (api, payload) => {
    const res = await beforeLoginAxios({
        method: "post",
        url: api,
        data: payload,
    });

    if (res) {
        return [res, false];
    }
    return [null, true]; // [response, error]
};

export const doctorLoginWithPasswordOrOTP = async (api, payload) => {
    const res = await beforeLoginAxios({
        method: "post",
        url: api,
        data: payload,
    });

    if (res) {
        return [res, false];
    }
    return [null, true]; // [response, error]
};
